import React from 'react'
import PropTypes from 'prop-types'
import ExploreFilterPage from './browseBy/ExploreFilterPage'
import ExploreCarouselPage from './carousel/ExploreCarouselPage'
import { getStore } from '../../../redux/store'
import { Provider } from 'react-redux'
import camelize from 'camelize'
import './Explore.scss'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

class ExplorePage extends React.Component {
  renderExplorePage() {
    const jsonCategories = this.props.categories
    const jsonFeaturedProducts = this.props?.featuredProducts
      ? this.props?.featuredProducts
      : ''
    const jsonInstructorOptions = camelize(this.props.instructorList)
    const jsonProps = {
      ...this.props,
      categories: jsonCategories,
      featuredProducts: jsonFeaturedProducts,
      instructorOptions: jsonInstructorOptions,
      equipmentTags: this.props.equipmentTags,
      defaultOrder: this.props.defaultOrder || 'date',
      focusAreaTags: this.props.focusAreaTags,
      userPresent: Boolean(this.props.userPresent),
      currentUser: this.props.currentUser
    }

    if (this.props.pageVersion === 'filter') {
      return <ExploreFilterPage {...jsonProps} />
    } else {
      return (
        <ExploreCarouselPage
          allProductCount={this.props.allProductCount}
          categories={jsonCategories}
          featuredProducts={jsonFeaturedProducts}
          baseUrl={this.props.baseUrl}
        />
      )
    }
  }

  render() {
    return (
      <Provider store={getStore()}>
        <ThemeProvider theme={LightTheme}>
          {this.renderExplorePage()}
        </ThemeProvider>
      </Provider>
    )
  }
}

ExplorePage.propTypes = {
  allProductCount: PropTypes.number,
  baseUrl: PropTypes.string,
  categories: PropTypes.string,
  difficulty: PropTypes.string,
  intensity: PropTypes.string,
  prefilteredCategories: PropTypes.string,
  defaultOrder: PropTypes.string,
  pageVersion: PropTypes.string,
  featuredProducts: PropTypes.string,
  equipmentTags: PropTypes.object,
  focusAreaTags: PropTypes.object,
  instructorList: PropTypes.object
}

export default ExplorePage
